// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1i-jJ","label":"CategoryService_label__3IqcW","location":"CategoryService_location__2GCmj"};